document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('tslogin-form');
  
    document.querySelector('#tsform-submit').addEventListener('click', function(event) {
        event.preventDefault();
  
        document.querySelector('#ts-spinner').style.display = 'block';
        document.querySelector('#tsform-submit').disabled = true;
  
        var formData = new FormData(form);
        
        var object = {};
        formData.forEach((value, key) => object[key] = value);
        var jsonData = JSON.stringify(object);
  
        // Parse jsonData to access keys/values
        var parsedData = JSON.parse(jsonData);
        var schoolName = parsedData['select-school']
  
        // Add the session ID as a cart attribute
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                teamstore_name: schoolName
              }
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Session ID stored in cart:', data);
  
            setTimeout(function(){
              window.location.href = `https://golfteamproducts.com/pages/teamstores?storeId=${schoolName}`;
            }, 2000)
            
          })
          .catch((error) => {
            console.error('Error:', error);
            document.querySelector('#ts-spinner').style.display = 'none';
            document.querySelector('#tsform-submit').disabled = false;
            document.querySelector('#error').innerHTML = `<div class="alert alert-danger" role="alert">Sorry, there was an error submitting your form: ${error.message}. Please try again.</div>`;
            document.querySelector('#tsform-submit').disabled = false;
        });
    });
  });  